const state = {
  mobileCheck: {
    version: '',
    os: ''
  }
}

const getters = {
  getMobileCheck: state => state.mobileCheck
}

const mutations = {
  SET_VERSION (state, payload) {
    state.mobileCheck.version = payload
  },
  SET_OS (state, payload) {
    state.mobileCheck.os = payload
  }
}

const actions = {
}

export default {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
